<template>
  <div class="api-scopes-picker">
    <v-row>
      <v-col cols="12" md="6">
        <v-card class="ma-2 pa-2">
          <h1 class="display-1 mt-4">Default Scopes</h1>
          <v-text-field
            v-model="defaultSearch"
            clearable
            flat
            class="mx-2 my-4"
            prepend-inner-icon="search"
            label="Search"
          ></v-text-field>
          <v-list
            two-line
            v-if="filteredDefaultScopes.length > 0"
            height="300px"
            class="overflow-y-auto"
          >
            <template v-for="(scope, index) in filteredDefaultScopes">
              <v-list-item :key="scope.uuid" dense>
                <v-list-item-content>
                  <v-list-item-title v-text="scope.name"></v-list-item-title>
                </v-list-item-content>
                <v-list-item-action class="my-0">
                  <v-btn
                    color="error"
                    class="text-right"
                    small
                    @click="$emit('removeDefault', scope.uuid)"
                  >Remove</v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-divider v-if="index + 1 < filteredDefaultScopes.length" :key="index"></v-divider>
            </template>
          </v-list>
          <div v-else>
            <v-row justify="center" align="center" style="height:300px">
              <v-icon size="64" class="my-5" left>sentiment_dissatisfied</v-icon>
              <span class="title">No content</span>
            </v-row>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card class="ma-2 pa-2">
          <h1 class="display-1 mt-4">Optional Scopes</h1>
          <v-text-field
            v-model="optionalSearch"
            clearable
            flat
            class="mx-2 my-4"
            prepend-inner-icon="search"
            label="Search"
          ></v-text-field>
          <v-list
            two-line
            v-if="filteredOptionalScopes.length > 0"
            height="300px"
            class="overflow-y-auto"
          >
            <template v-for="(scope, index) in filteredOptionalScopes">
              <v-list-item :key="scope.uuid">
                <v-list-item-content>
                  <v-list-item-title v-text="scope.name"></v-list-item-title>
                </v-list-item-content>
                <v-list-item-action class="my-0">
                  <v-btn
                    color="error"
                    class="text-right"
                    small
                    @click="$emit('removeOptional', scope.uuid)"
                  >Remove</v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-divider v-if="index + 1 < filteredOptionalScopes.length" :key="index"></v-divider>
            </template>
          </v-list>
          <div v-else>
            <v-row justify="center" align="center" style="height:300px">
              <v-icon size="64" class="my-5" left>sentiment_dissatisfied</v-icon>
              <span class="title">No content</span>
            </v-row>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-divider>"</v-divider>
    <v-col cols="12" md="12">
      <v-card class="pa-2">
        <h1 class="display-1 mt-4">Available Scopes</h1>
        <v-text-field
          v-model="availableSearch"
          clearable
          flat
          class="mx-2 my-4"
          prepend-inner-icon="search"
          label="Search"
        ></v-text-field>
        <v-list
          two-line
          v-if="filteredAvailableScopes.length > 0"
          max-height="600px"
          class="overflow-y-auto"
        >
          <template v-for="(scope, index) in filteredAvailableScopes">
            <v-list-item :key="scope.uuid">
              <v-list-item-content>
                <v-list-item-title v-text="scope.name"></v-list-item-title>
                <v-list-item-subtitle v-text="scope.description"></v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn
                  color="success"
                  class="text-right"
                  small
                  @click="$emit('AddDefault', scope.uuid)"
                >Default</v-btn>
              </v-list-item-action>
              <v-list-item-action>
                <v-btn
                  color="success"
                  class="text-right"
                  small
                  @click="$emit('addOptional', scope.uuid)"
                >Optional</v-btn>
              </v-list-item-action>
            </v-list-item>
            <v-divider v-if="index + 1 < filteredAvailableScopes.length" :key="index"></v-divider>
          </template>
        </v-list>
        <div v-else>
          <v-row justify="center" align="center">
            <v-icon size="64" class="my-5" left>sentiment_dissatisfied</v-icon>
            <span class="title">No content</span>
          </v-row>
        </div>
      </v-card>
    </v-col>
  </div>
</template>

<script>
export default {
  props: {
    availableScopes: { type: Array, required: true },
    defaultScopes: { type: Array, required: true },
    optionalScopes: { type: Array, required: true }
  },
  data() {
    return {
      availableSearch: "",
      defaultSearch: "",
      optionalSearch: ""
    };
  },
  computed: {
    filteredAvailableScopes() {
      var searchFiltered = this.availableScopes.filter(scope =>
        scope.name.toLowerCase().includes(this.availableSearch.toLowerCase())
      );
      var uuids = this.defaultScopes
        .map(scope => scope.uuid)
        .concat(this.optionalScopes.map(scope => scope.uuid));
      return searchFiltered.filter(scope => !uuids.includes(scope.uuid));
    },
    filteredDefaultScopes() {
      return this.defaultScopes.filter(scope =>
        scope.name.toLowerCase().includes(this.defaultSearch.toLowerCase())
      );
    },
    filteredOptionalScopes() {
      return this.optionalScopes.filter(scope =>
        scope.name.toLowerCase().includes(this.optionalSearch.toLowerCase())
      );
    }
  }
};
</script>

<style scoped>
</style>